// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.update-notice[data-v-11a23788] {\r\n  background-color: #fff0ec;\r\n  border-radius: 6px;\r\n  padding: 14px 18px;\r\n  margin-bottom: 20px;\r\n  color: #ff7a59;\r\n  text-align: center;\n}\n.update-notice__title[data-v-11a23788] {\r\n  font-weight: 600;\r\n  margin-bottom: 6px;\n}\n.b-checkbox.checkbox[data-v-11a23788] .control-label {\r\n  padding-left: 0.75em;\r\n  padding-right: 8px;\n}\r\n", ""]);
// Exports
module.exports = exports;
